import React, { FC } from 'react';
import CN from 'classnames';

interface Styles {
    root?: string;
    header?: string;
    body?: string;
}

export interface OrderSelectBaseLayoutProps {
    classNames?: Styles;
    header: React.ReactNode;
    body: React.ReactNode;
    type?: number;
}

export const OrderSelectBaseLayout: FC<OrderSelectBaseLayoutProps> = (
    props,
) => {
    const {
        classNames, header, body, type = 2, children,
    } = props;

    const rc = classNames?.root;
    const hc = classNames?.header;
    const hb = classNames?.body;

    const rootClassName = CN(
        {
            'order-select-base-layout': type === 1,
            'order-select-base-layout-2': type === 2,
        },
        rc,
    );
    const headerClassName = CN('header', hc);
    const bodyClassName = CN('body', hb);

    return (
        <div className={rootClassName}>
            <div className={headerClassName}>{header}</div>
            <div className={bodyClassName}>{body}</div>
            {children}
        </div>
    );
};
